$(".reviews--slider__container").slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 3,
  dots: true,
  adaptiveHeight: true,
  arrows: true,
  prevArrow:
    '<button type="button" aria-label="Previous reviews" class="fs-slideshow__nav-button fs-slideshow__nav-button--new slick-prev"><svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none"> <circle cx="26.0305" cy="26.1348" r="25.6536" fill="#204632"/> <path d="M28.7461 16.3416L18.953 26.1346L28.7461 35.9277" stroke="white" stroke-width="2"/> </svg></button>',
  nextArrow:
    '<button type="button" aria-label="Next reviews" class="fs-slideshow__nav-button fs-slideshow__nav-button--new slick-next"><svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none"> <circle cx="25.6536" cy="25.6536" r="25.6536" transform="matrix(-1 0 0 1 51.623 0.481201)" fill="#204632"/> <path d="M23.2537 16.3416L33.0468 26.1346L23.2537 35.9277" stroke="white" stroke-width="2"/> </svg></button>',
  responsive: [
    {
      breakpoint: 1000,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: "20px",
        fade: false,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

$(document).ready(function () {
  // (Optional) Active an item if it has the class "is-active"
  $(".faqs .accordion > .accordion-item.is-active")
    .children(".accordion-panel")
    .slideDown();
  $(".faqs .accordion .accordion-thumb").click(function () {
    // Cancel the siblings
    $(this)
      .toggleClass("is-active-thumb")
      .closest(".accordion-item")
      .toggleClass("is-active")
      .find(".accordion-panel")
      .slideToggle();
    $(this).find(".icon").toggleClass("rotate--icons");
    // A11y: announce open/closed state
    var faqButton = $(this).find(".accordion-thumb__button");
    faqButton.attr("aria-expanded", $(this).hasClass("is-active-thumb") ? "true" : "false");
    // Toggle the item
    //$(this).closest(".accordion-item").toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
  });
  $(".show-full-ingredients-popup-button").click(function () {
    $(".show-full-ingredients-list").show();
  });
  $(".show-full-ingredients-list-cross").click(function () {
    $(".show-full-ingredients-list").hide();
  });
});
